import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "@phosphor-icons/react";

const KEY = "sigsaop_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setVisible(true);
  }, []);

  const persist = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({
      choice, ts: new Date().toISOString(),
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[70] px-3 pb-3 sm:px-6 sm:pb-6 pointer-events-none"
    >
      <div className="pointer-events-auto max-w-4xl mx-auto rounded-2xl bg-slate-950 text-white shadow-2xl border border-white/10 backdrop-blur">
        <div className="p-5 sm:p-6 flex flex-col md:flex-row gap-4 md:items-center">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 rounded-lg bg-brand-orange-500/15 text-brand-orange-400 flex items-center justify-center flex-shrink-0">
              <Cookie size={20} weight="duotone" />
            </div>
            <div className="text-sm leading-relaxed">
              <div className="font-semibold text-white mb-1">Usamos cookies para que el sitio funcione</div>
              <div className="text-slate-300">
                SIGSAOP utiliza cookies estrictamente necesarias para la autenticación y funcionamiento
                de la plataforma. No usamos cookies de análisis, publicidad ni de terceros. Ver{" "}
                <Link to="/cookies" className="text-brand-orange-400 hover:text-brand-orange-300 underline underline-offset-2">
                  Política de Cookies
                </Link>
                {" "}y{" "}
                <Link to="/privacidad" className="text-brand-orange-400 hover:text-brand-orange-300 underline underline-offset-2">
                  Política de Privacidad
                </Link>.
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 justify-end flex-shrink-0">
            <button
              onClick={() => persist("rejected")}
              data-testid="cookie-reject-btn"
              className="rounded-md px-4 py-2 text-sm font-medium text-slate-300 hover:bg-white/10 border border-white/15"
            >
              Solo necesarias
            </button>
            <button
              onClick={() => persist("accepted")}
              data-testid="cookie-accept-btn"
              className="rounded-md bg-brand-orange-500 hover:bg-brand-orange-600 px-4 py-2 text-sm font-semibold text-white"
            >
              Aceptar
            </button>
            <button
              onClick={() => persist("dismissed")}
              aria-label="Cerrar"
              data-testid="cookie-dismiss-btn"
              className="rounded-md text-slate-400 hover:text-white p-2"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
